import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";
import {TenantSettingsContent} from "./payloads/tenant-settings-content";

/**
 * Saves the tenant's settings (feature plan 0068), today the start page. Mirrors the backend
 * `save.tenant-settings` command. Like the theme it has no entity, so `mainEntityClass` is the synthetic
 * marker `'tenant-settings'` and `mainEntityUid` the tenant.
 *
 * No transformer (ADR-016): the payload is a `CommandPayload`, serialized by the generic path in
 * `TransformerHelper`. Do not add a `save-tenant-settings-command-to-dto.transformer.ts` — an
 * architecture test refuses it.
 */
export class SaveTenantSettingsCommand extends AbstractCommand<TenantSettingsContent> {

    public name: CommandName = CommandName.SAVE_TENANT_SETTINGS;

    public tags = ['tenant-settings', 'save'];

    constructor(tenant: string, content: TenantSettingsContent) {
        super('tenant-settings', tenant, content);
    }

}
